import {
  ActionType,
  getActionTypeFromInstance,
  NgxsNextPluginFn,
} from '@ngxs/store';
import { Auth } from '../auth/auth.actions';
import { AuthStateModel } from '../auth/auth.state';

const initialAuthState: AuthStateModel = {
  token: null,
  user: null,
  loading: false,
  error: null,
  forgotPassword: false,
  resetPassword: false,
  logout: false,
  changePassword: false,
  credentials: null
};

export function logoutPlugin(
  state: any,
  action: ActionType,
  next: NgxsNextPluginFn
) {
  if (!state || !state.auth) {
    return next(state, action);
  }

  if (getActionTypeFromInstance(action) === Auth.LogoutSuccess.type) {
    const credentials = state.auth.credentials;

    state = {
      ...state,
      auth: {
        ...initialAuthState,
        credentials
      }
    };
  }

  return next(state, action);
}
